<template>
  <Layout>
    <PageHeader :items="items" />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">{{ title }}</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'variablesList' }"
          >
            <b-icon
              class="icon-plus"
              icon="arrow90deg-left"
            ></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <div class="row">
          <div class="pre-variables-container h-100">
            <div class="ml-2 mt-1 mb-2 title-card-app">Tipo de Variables</div>
            <div class="variables-container">
              <Drag type="text" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'text',
                    disabled: editMode && typeVariable !== 'text',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'text' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-file-font></b-icon-file-font
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Texto</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="integer" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'integer',
                    disabled: editMode && typeVariable !== 'integer',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'integer' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title><b-icon-hash></b-icon-hash></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Número Entero</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="decimal" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'decimal',
                    disabled: editMode && typeVariable !== 'decimal',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'decimal' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title><b-icon-hash></b-icon-hash></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Número Decimal</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="alphanumeric" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'alphanumeric',
                    disabled: editMode && typeVariable !== 'alphanumeric',
                  }"
                  @click="
                    !editMode
                      ? selectTypeVariable({ type: 'alphanumeric' })
                      : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title><b-icon-type></b-icon-type></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Alfanumérico</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="image" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'image',
                    disabled: editMode && typeVariable !== 'image',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'image' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-card-image></b-icon-card-image
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Imagen</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="file" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'file',
                    disabled: editMode && typeVariable !== 'file',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'file' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-file-richtext></b-icon-file-richtext
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1">PDF</b-card-text>
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="address" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'address',
                    disabled: editMode && typeVariable !== 'address',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'address' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-geo-alt></b-icon-geo-alt
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Dirección</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="email" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'email',
                    disabled: editMode && typeVariable !== 'email',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'email' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title><b-icon-at></b-icon-at></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Email</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="date" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'date',
                    disabled: editMode && typeVariable !== 'date',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'date' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-calendar2-minus></b-icon-calendar2-minus
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Fecha</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="time" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'time',
                    disabled: editMode && typeVariable !== 'time',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'time' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title><b-icon-clock></b-icon-clock></b-card-title>
                    <b-card-text class="text-center m-0 pt-1">Hora</b-card-text>
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="list" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'list',
                    disabled: editMode && typeVariable !== 'list',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'list' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-list-task></b-icon-list-task
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Lista</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
              <Drag type="boolean" :vibration="10">
                <b-card
                  no-body
                  class="card-variable m-0"
                  :class="{
                    'bg-info': typeVariable === 'boolean',
                    disabled: editMode && typeVariable !== 'boolean',
                  }"
                  @click="
                    !editMode ? selectTypeVariable({ type: 'boolean' }) : null
                  "
                >
                  <b-card-body class="p-0 m-0 mx-2 mt-2 text-center">
                    <b-card-title
                      ><b-icon-toggle-on></b-icon-toggle-on
                    ></b-card-title>
                    <b-card-text class="text-center m-0 pt-1"
                      >Booleano</b-card-text
                    >
                  </b-card-body>
                </b-card>
              </Drag>
            </div>
          </div>
          <div
            class="forms-container p-0 pb-3 dnd-drop-cont"
          >
            <Drop
              @drop="selectTypeVariable"
              class="section-card list2 empty mt-2"
              mode="copy"
            >
              <textComponent
                v-if="typeVariable === 'text'"
                :variableDataComponent="variableData"
              />
              <integerComponent
                v-else-if="typeVariable === 'integer'"
                :variableDataComponent="variableData"
              />
              <decimalComponent
                v-else-if="typeVariable === 'decimal'"
                :variableDataComponent="variableData"
              />
              <imageComponent
                v-else-if="typeVariable === 'image'"
                :variableDataComponent="variableData"
              />
              <emailComponent
                v-else-if="typeVariable === 'email'"
                :variableDataComponent="variableData"
              />
              <alphanumericComponent
                v-else-if="typeVariable === 'alphanumeric'"
                :variableDataComponent="variableData"
              />
              <fileComponent
                v-else-if="typeVariable === 'file'"
                :variableDataComponent="variableData"
              />
              <addressComponent
                v-else-if="typeVariable === 'address'"
                :variableDataComponent="variableData"
              />
              <dateComponent
                v-else-if="typeVariable === 'date'"
                :variableDataComponent="variableData"
              />
              <timeComponent
                v-else-if="typeVariable === 'time'"
                :variableDataComponent="variableData"
              />
              <listComponent
                v-else-if="typeVariable === 'list'"
                :variableDataComponent="variableData"
              />
              <booleanComponent
                v-else-if="typeVariable === 'boolean'"
                :variableDataComponent="variableData"
              />
            </Drop>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import textComponent from '@/src/components/variables/text'
import integerComponent from '@/src/components/variables/integer'
import decimalComponent from '@/src/components/variables/decimal'
import alphanumericComponent from '@/src/components/variables/alphanumeric'
import imageComponent from '@/src/components/variables/image'
import emailComponent from '@/src/components/variables/email'
import fileComponent from '@/src/components/variables/file'
import addressComponent from '@/src/components/variables/address'
import dateComponent from '@/src/components/variables/date'
import timeComponent from '@/src/components/variables/time'
import listComponent from '@/src/components/variables/list'
import booleanComponent from '@/src/components/variables/boolean'
import { variablesMethods } from '@state/helpers'
import { Drag, Drop, DropList } from 'vue-easy-dnd'

export default {
  page: {
    title: 'Variables',
  },
  components: {
    Layout,
    PageHeader,
    textComponent,
    integerComponent,
    decimalComponent,
    imageComponent,
    emailComponent,
    alphanumericComponent,
    fileComponent,
    addressComponent,
    dateComponent,
    timeComponent,
    listComponent,
    booleanComponent,
    Drag,
    Drop,
    DropList,
  },
  data() {
    return {
      selectVariable: false,
      typeVariable: '',
      editMode: false,
      selected: false,
      variableData: {
        id: null,
        label: '',
        dimension: null,
        order: null,
        description: '',
        state: 'A',
        classification: '2',
        config: {},
        privacy: null,
      },
      title: 'Crear nueva variable',
      items: [
        { text: '/', path: '/home', to: { name: 'home' } },
        {
          text: this.$route.params.variableId
            ? 'Actualizar variable'
            : 'Crear nueva variable',
          active: true,
        },
      ],
      extraButtons: [
        {
          variant: 'success',
          title: 'Listar Variables',
          to: { name: 'variablesList' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  beforeMount() {
    if (this.$route.params.variableId) {
      this.getVariables(this.$route.params.variableId).then((data) => {
        this.selectTypeVariable({
          type: data.type,
          title: 'Actualizar Variable',
        })
        this.variableData = data
        this.editMode = true
      })
    } else {
      this.editMode = false
    }
  },
  methods: {
    ...variablesMethods,

    selectTypeVariable(typeVariable) {
      // console.log("entro TypeVariable: ", typeVariable)
      this.typeVariable = typeVariable.type
      this.title = typeVariable.title || 'Crear Nueva Variable'
      this.selectVariable = true
      if (this.editMode === false) {
        this.variableData.config = {} // to clean config on click (only new)
      }
    },
  },
}
</script>

<style lang="scss">
.card.card-variable.bg-info {
  background-color: #48c0f5 !important;
  .b-icon {
    fill: white;
  }
  .card-title {
    background-color: transparent !important;
  }
  .card-text {
    color: white;
  }
}
.with-separator {
  border-top: 1px solid #dee2e6 !important;
}
.pre-variables-container {
  @media (max-width: 575px) {
    width: 100%;
  }
}
.variables-container {
  background-color: white;
  display: grid;
  grid-gap: 10px;
  // padding-left: 10px;
  @media (max-width: 575px) {
    width: 100%;
    grid-template: repeat(4, 1fr) / repeat(3, 1fr);
    .card-variable {
      width: 100% !important;
      height: 80px !important;
      .card-title {
        margin-bottom: 5px;
      }
      .card-text {
        border-top: 0px !important;
        padding-top: 0px !important;
        font-size: 0.7rem;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  @media (min-width: 576px) {
    width: 154px;
  }
  @media (min-width: 992px) {
    width: 300px;
    grid-template: repeat(2, 1fr) / repeat(2, 1fr);
  }

  .card-variable {
    background-color: white;
    border: 1px dashed #48c0f5;
    border-bottom: 3px solid #48c0f5;
    border-radius: 5px;
    cursor: pointer;
    width: 134px;
    height: 108px;
    .card-title {
      background-color: transparent;
    }
    .card-text {
      border-top: 2px dashed #bfe9fb;
    }
    &.disabled {
      background-color: rgb(241, 241, 241);
      border: 1px dashed #6d6d6d;
      border-bottom: 3px solid #8a8a8a;

      .card-text {
        border-top: 2px dashed #c5c5c5;
      }
    }
  }
  .card-variable:hover .b-icon {
    -webkit-transform: scale(1.75);
    transform: scale(1.4);
    transition: all 0.15s;
  }
}
.forms-container {
  @media (min-width: 576px) {
    width: calc(100% - 154px);
  }
  @media (min-width: 992px) {
    width: calc(100% - 300px);
  }
  .tabs .card-header,
  .nav-tabs {
    background-color: transparent !important;
  }
}

.card-form {
  background-color: white;
  border-radius: 10px;
}

.list2 {
  min-height: 140px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // height: 50%;
  .card {
    border: 1px dashed #48c0f5;
    border-bottom: 3px solid #48c0f5;
    border-radius: 5px;

    .handle-cursor:hover {
      background-color: #48c1f51f;
    }

    .handle-cursor {
      cursor: move;
    }
  }

  .empty {
    text-align: center;
    // background-color: #f5fafd;
    padding: 10px;
  }
  &.empty::before {
    content: 'Arrastre y suelte aquí el tipo de variable a crear';
    background-image: url('~~~@assets/images/add-form-img.png');
    background-position: center center;
    background-repeat: no-repeat;
    color: rgb(204, 204, 204);
    font-size: 14px;
    width: 100%;
    text-align: center;
    margin-top: 18px;
    min-height: 100px;
    margin-bottom: -20px;
  }
  &.drop-allowed.empty::before {
    content: 'Suelte aquí para crear la variable';
    width: 100%;
    text-align: center;
    background-image: none;
    font-size: 16px;
  }
  &.drop-forbidden {
    background-color: rgba(255, 0, 0, 0.12);
  }
  &.drop-allowed {
    background-color: rgba(61, 65, 255, 0.12);
  }
}
</style>
